var map = {
	"./event.js": 202,
	"./items.js": 647,
	"./screen.js": 648,
	"./snack-bar.js": 649
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 646;


//////////////////
// WEBPACK FOOTER
// ./src/reducers ^(.*\.(js$))[^.]*$/i
// module id = 646
// module chunks = 0